var React = require('react');

function StepCircle1048px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-6.452 32h2.21V15.1h-1.95l-3.692 1.976.442 1.742 2.938-1.586h.052V32zm12.28.286h-.026c-3.302 0-5.564-3.094-5.616-8.684 0-5.694 2.47-8.788 5.902-8.788 3.536 0 5.59 3.172 5.59 8.554 0 5.746-2.158 8.918-5.85 8.918zm.078-1.768h.026c2.314 0 3.432-2.73 3.432-7.046 0-4.16-1.04-6.89-3.432-6.89-2.08 0-3.432 2.652-3.432 6.89-.052 4.394 1.3 7.046 3.406 7.046z"}));
}

StepCircle1048px.displayName = "StepCircle1048px";

StepCircle1048px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle1048px;

StepCircle1048px.default = StepCircle1048px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-10-48px.svg
// module id = 1161
// module chunks = 0